<template>
  <div>
    <basic-container>
      <div class="page-container partner-manage-page">
        <!-- 搜索 -->
        <div class="query-form-wrap">
          <el-form :inline="true" :model="form" :size="formSize">
            <el-form-item>
              <el-input clearable v-model="form.name" placeholder="配置名称"></el-input>
            </el-form-item>
            <el-form-item>
              <el-input clearable v-model="form.account" placeholder="账号名称"></el-input> 
            </el-form-item>
            <el-form-item>
              <el-select v-model="form.type" collapse-tags multiple size="small" clearable placeholder="配置类型">
                <el-option label="系统预设配置" :value="1"></el-option>
                <el-option label="系统默认配置" :value="2"></el-option>
                <el-option label="用户配置" :value="3"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button :loading="listLoading" icon="el-icon-search" type="primary" @click="handleSearch">搜索</el-button>
              <el-button @click="openDialog" icon="el-icon-plus" plain type="primary" v-auth="'enterpriseSetting_add'">新增</el-button>
              <el-button icon="el-icon-delete" plain type="danger" @click="handleDelete" v-auth="'enterpriseSetting_del'">删除</el-button>
            </el-form-item>
          </el-form>
        </div>
        <!-- 操作 -->

        <!-- 列表 -->
        <el-table 
          :cell-style="{'text-align':'center'}"
          :header-cell-style="{'text-align':'center'}"
          :max-height="tableHeight"
          v-loading="listLoading"
          element-loading-text="加载中"
          style="width: 100%"
          border
          :data="tableDataList"
          @selection-change="handleSelect">
          <el-table-column 
            type="selection">
          </el-table-column>
          <el-table-column 
            prop="name"
            fixed
            label="配置名称"
            align="center"
            header-align="center">
          </el-table-column>
          <el-table-column 
            prop="icon"
            align="center"
            header-align="center"
            label="企业ICON">
            <template slot-scope="scope">
              <img :src="scope.row.icon" height="30px"  />
            </template>
          </el-table-column>
          <el-table-column 
            prop="bgImages"
             align="center"
            header-align="center"
            label="所传壁纸">
            <template slot-scope="scope">
              <ul class="bgImages_box">
                <li v-for="(item, index) in scope.row.bgImages.split(',')" :key="index" @click="showPreviewImg(item)"><img :src="item" height="30px"  /></li>
              </ul>
            </template>
          </el-table-column>
          <el-table-column 
            prop="showDuration"
            align="center"
            header-align="center"
            width="120"
            label="间隔时间(s)">
          </el-table-column>
          <el-table-column 
            prop="createTime"
            align="center"
            header-align="center"
            label="时间">
          </el-table-column>
          <el-table-column 
            prop="bindUserAccount"
            align="center"
            header-align="center"
            label="所属账号">
          </el-table-column>
          <el-table-column 
            prop="type"
            align="center"
            header-align="center"
            label="配置类型">
            <template slot-scope="scope">
              <el-tag type="success" effect="dark"  v-if="scope.row.type == 2 ">系统默认配置</el-tag>
              <el-tag type="warning" effect="dark" v-if="scope.row.type == 1 ">系统预设配置</el-tag>
              <el-tag type="primary" effect="dark" v-if="scope.row.type == 3 ">用户配置</el-tag>
            </template>
          </el-table-column>
          <el-table-column 
            fixed="right"
            width="300"
            label="操作">
            <template slot-scope="scope">
              <el-button 
                v-auth="'enterpriseSetting_edit'"
                @click="openDialog(scope.row)"
                size="small"
                type="text">
                修改
              </el-button>
              <el-button 
                v-auth="'enterpriseSetting_del'"
                @click="handerDel(scope.row)"
                size="small"
                type="text">
                删除
              </el-button>
              <el-button 
                v-auth="'enterpriseSetting_view'"
                @click="openDialog(scope.row, true)"
                size="small"
                type="text">
                查看
              </el-button>
              <el-button
                v-auth="'enterpriseSetting_use'"
                v-if="scope.row.type == 1"
                @click="useSetting(scope.row)"
                size="small"
                type="text">
                启用配置
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="table-pagination">
          <TablePagination 
          :page-size.sync="pageConfig.size"
          :total="total"
          :current-page.sync="pageConfig.current"
          @change="handlePageChange" />
        </div>
      </div>

      <!-- 表单 -->
      <el-dialog 
        :title="dialogType"
        :visible.sync="showDialog"
        append-to-body
        width="40%"
        :before-close="handleAddOrEditClose"
        top="5vh">

        <el-form 
          ref="dialogForm"
          :rules="formRule"
          :model="checkItem"
          :disabled=" dialogType==='查看' ? true : false"
          label-width="80px">
          <el-form-item 
            label="配置名称"
            prop="name">
            <el-input 
              placeholder="请输入配置名称"
              v-model="checkItem.name">
            </el-input>
          </el-form-item>
          <el-form-item
            label="企业icon"
            prop="icon">    
            <el-upload
              ref="uploadIcon"
              action="#"
              :limit="1"
              list-type="picture-card"
              :file-list="icon"
              :on-change="handleChangeIcon"
              :on-remove="handleRemoveIcon"
              :on-exceed="handleExceedToast"
              :auto-upload="false"
              accept=".jpeg,.jpg,.png"
            >
            <i slot="default" class="el-icon-plus"></i>
            </el-upload>
          </el-form-item>
          <el-form-item
            label="所传壁纸"
            prop="bgImages">    
            <el-upload
              ref="uploadImg"
              action="#"
              :limit="7"
              list-type="picture-card"
              :file-list="bgImages"
              :on-change="handleChangebg"
              :before-upload ="beforeAvatarUpload"
              :on-remove="handleRemovebg"
              :on-exceed="handleExceedbgToast"
              :auto-upload="false"
              accept=".jpeg,.jpg,.png"
            >
            <i slot="default" class="el-icon-plus"></i>
            </el-upload>
          </el-form-item>
          <el-form-item
            label="间隔时间" 
            prop="showDuration">
            <el-select v-model="checkItem.showDuration" size="small" placeholder="选择会员类型名称">
              <el-option label="1秒" :value="1"></el-option>
              <el-option label="3秒" :value="3"></el-option>
              <el-option label="5秒" :value="5"></el-option>
              <el-option label="10秒" :value="10"></el-option>
              <el-option label="15秒" :value="15"></el-option>
              <el-option label="30秒" :value="30"></el-option>
              <el-option label="60秒" :value="60"></el-option>
            </el-select>
          </el-form-item>
        </el-form>

        <div slot="footer" class="dialog-footer">
          <el-button
            v-if="dialogType!=='查看'" 
            @click="submitChange('ruleForm')"
            size="small"
            type="primary"
            icon="el-icon-circle-check">
            保存
          </el-button>
          <el-button 
            @click="handleAddOrEditClose"
            size="small"
            icon="el-icon-circle-close">
            取消
          </el-button>
        </div>
      </el-dialog>

      <!-- 图片预览 -->
      <el-dialog title="图片预览"  append-to-body width="50%"
          :visible.sync="dialogShowPreviewImg">
        <!-- <video :src="playURL" id="vide" controls="controls" width="100%"></video> -->
        <img :src="previewImg" width="100%">
      </el-dialog>
    </basic-container>

  </div>
</template>
<script>
import { merge, debounce, deepCopy } from '@/util/common';
import ListMixins from '@/util/mixins/listPage';
import { getdongleConfigList, putFile, settingSubmit, enterpriseSettingRemove, enterpriseSettingUse } from "@/api/leboHardwareManage/leboHardwareManage";
// import { getdongleConfigList, putFile } from "@/api/leboHardwareManage/leboHardwareManage";
export default {
  name: 'enterpriseUser',
  mixins: [ListMixins],
  data () {
    return {
      listLoading: false,
      form: {     //查询的时候需要用到的参数
        name: '',
        account: '',
        type: []
      },
      delids: '',
      checkItem: {  // 选中编辑/新增需要得数据   
        name: '',
      },
      formRule: {
        name: [{ required: true, message: '请输入配置名称', trigger: 'blur' }],
        icon: [{required: true, message: '请上传icon', trigger: 'blur' }],
        bgImages: [{required: true, message: '请上传企业壁纸', trigger: 'blur' }],
        showDuration: [{required: true, message: '请选择间隔时间', trigger: 'blur'}]
      },
      icon:[],
      bgImages: [],
      dialogType: '',
      tableDataList: [], // 列表数据
      pageConfig: {},
      total: 0,
      showDialog: false,
      dialogShowPreviewImg: false,
      previewImg: ''
    }
  },
  created () {
    this.getList();
  },
  methods: {
    getList() {
      this.listLoading = true
      let query = merge({}, this.form, this.pageConfig)
      query.type = query.type.join(',')
      console.log('query', query)
      let onSuccess = res => {
        this.listLoading = false
        if (res.data.code === 200) {
          this.tableDataList = res.data.data.records
          this.pageConfig.size = res.data.data.size
          this.pageConfig.current = res.data.data.current
          this.total = res.data.data.total
        } else {
          this.$message.error(res.data.msg)
        }
      }
      getdongleConfigList(query).then(onSuccess).catch(() => { this.listLoading = false })
    },
    // 启用配置
    useSetting(row) {
      this.$confirm('确定要将此配置设为默认配置么？', '提示', {
        type: 'warning'
      }).then(() => {
        enterpriseSettingUse(row.id).then(res => {
          if (res.data.code === 200) {
            this.$message.success('操作成功')
            this.getList()
          } else {
            this.$message.error(res.data.msg)
          }
        })
      })
    },
    // 预览图片
    showPreviewImg(imgurl) {
      this.previewImg = imgurl
      this.dialogShowPreviewImg = true
    },
    // 列删除
    handerDel(row) {
      this.$confirm('确定要删除选中的数据吗？', '提示', {
        type: 'warning'
      }).then(() => {
        this.rowRemove(row.id)
      })
    },
    //删除
    rowRemove(id) {
      enterpriseSettingRemove(id).then(res => {
        if (res.data.code === 200) {
          this.$message.success('操作成功')
          this.getList()
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    // 批量删除
    handleDelete() {
      if (this.selectedRows.length > 0) {
        this.$confirm('确定要删除选择的记录吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          const ids = this.selectedRows.map(item => item.id).join(',')
          enterpriseSettingRemove(ids).then(res => {
            if (res.data.code === 200) {
              this.selectedRows = []
              this.getList()
            } else {
              this.$message.error(res.data.msg)
            }
          })
        })
      } else {
        this.$alert('请选择要删除的记录', '提示', {
          confirmButtonText: '知道了',
        });
      }
    },
    // 选择数据
    handleSelect(selection) {
      console.log(selection)
      this.selectedRows = selection;
    },
    // 转换格式
    formate(arr) {
      let newArr = []
      for (let index = 0; index < arr.length; index++) {
        let obj = { name:'', url: arr[index] }
        newArr.push(obj)
      }
      return newArr
    },
    // 新增编辑查看弹窗
    openDialog (row, isView) {
      // 查看
      if (isView) {
        this.dialogType = '查看'
        this.checkItem = deepCopy(row)
        this.checkItem = deepCopy(row)
        this.checkItem.bgImages = this.checkItem.bgImages.split(',')
        this.icon = this.formate(row.icon.split(','))
        this.bgImages = this.formate(row.bgImages.split(','))
      } else {
        if (row.id) { // 编辑
          this.dialogType = '编辑'
          this.checkItem = deepCopy(row)
          this.checkItem.bgImages = this.checkItem.bgImages.split(',')
          this.icon = this.formate(row.icon.split(','))
          this.bgImages = this.formate(row.bgImages.split(','))
          console.log(this.bgImages)
        } else { // 新增
          this.dialogType = '新增'
          this.checkItem = {
            id: '',
            name: '',
            icon: '',
            bgImages: [],
            type: 1,
            showDuration: 3
          }
          this.icon = []
          this.bgImages = []
        }
      }
      this.showDialog = true
      console.log('[openDialog]', isView)
    },
    //关闭弹窗编辑或者新增
    handleAddOrEditClose () {
      console.log("[handleAddOrEditClose] 取消关闭弹窗清理数据")
      this.showDialog = false
      this.checkItem.icon = ''
      this.icon = []
      this.bgImages = []
      this.$refs.uploadIcon.clearFiles()
      this.$refs.dialogForm.resetFields()
    },
    // 启用
    handerEnable(row) {
      console.log('账号启用', row)
    },
    // 禁用
    handerDisable(row) {
      console.log('账号禁用', row)
    },
    // 查看
    handerView(row) {
      console.log('查看账号', row)
    },
    // 上传icon
    handleChangeIcon(file) {
      console.log('handleChangeIcon', file)
      const formData = new FormData();
      formData.append("file", file.raw);
      putFile(formData).then((res) => {
        if (res.data.code === 200) {
          this.checkItem.icon = res.data.data.link;
          this.$refs.dialogForm.clearValidate('icon')
          this.$forceUpdate();
          console.log(res.data.data.link);
        } else {
          this.$message.error(res.data.msg);
        }
      })
      console.log('checkitem', this.checkItem)
    },
    beforeAvatarUpload(file) {
      console.log('file', file)
    },
    // 上传bg
    handleChangebg(file, fileList) {
      console.log('2222222222', fileList)
      if (file.size > 1024*1024) {
        this.$message.error('上传失败，请确保图片在1M以内')
        this.bgImages = fileList.pop()
        return
      }
      console.log('handleChangeIcon', file)
      const formData = new FormData();
      formData.append("file", file.raw);
      putFile(formData).then((res) => {
        if (res.data.code === 200) {
          this.checkItem.bgImages.push(res.data.data.link)
          let obj = {name:"", url: res.data.data.link}
          this.bgImages.push(obj)
          this.$refs.dialogForm.clearValidate('bgImages')
          this.$forceUpdate();
          console.log('this.bgImages', this.bgImages)
        } else {
          this.$message.error(res.data.msg);
        }
      })
      console.log('checkitem', this.checkItem)
    },
    // icon图片删除
    handleRemoveIcon() {
      console.log('删除后的checkitem', this.checkItem)
      console.log(this.bgImages)
      this.$refs.dialogForm.clearValidate('icon')
      this.bgImages = ''
      this.checkItem.icon = ''
    },
    // bg图片删除
    handleRemovebg(file, fileList) {
      // 不直接操作是因为FileList有额外参
      const index = fileList.findIndex(item => item === file.uid)
      console.log('file', file)
      console.log('fileList', fileList)
      console.log('index', index)
      this.bgImages.splice(index, 1)
      this.checkItem.bgImages.splice(index, 1)
      console.log('this.checkItem.bgImages', this.checkItem.bgImages)
      this.$refs.dialogForm.clearValidate('bgImages')
      console.log(this.bgImages)
    },
    // 上传文件超出显示提示
    handleExceedToast() {
      this.$message.error('最多只能上传一张封面ICON')
    },
    handleExceedbgToast() {
       this.$message.error('最多只能上传七张壁纸')
    },
    //提交更改内容
    submitChange: debounce(function () {
      console.log("[submitChange]", this.checkItem)
      this.$refs.dialogForm.validate((valid, value) => { 
        console.log('this.checkItem', this.checkItem)
        console.log(valid, value)
        if (valid) {
        let query = deepCopy(this.checkItem)
        query.bgImages = query.bgImages.toString()
        settingSubmit(query).then(res => {
          if (res.data.code === 200) {
            this.showDialog = false
            this.getList()
          } else {
            this.$message.error(res.data.msg)
          }
        })
          console.log('提交成功')
        } else {
          console.log('提交失败')
          // return false;
        }
      })

    }, 1000, false)
  }
}
</script>
<style lang="scss">
.table-pagination {
  margin-top: 20px;
  text-align: right;
}
.partner-manage-page {
  .cell-content {
    color: #008080;
    cursor: pointer;
    text-decoration: underline;
    display: inline-block;
    padding: 6px 10px;
    line-height: 1.3em;
  }
}
.bgImages_box {
  list-style: none !important;
  display: flex;
  padding: 0;
  li {
    float: left;
    margin-right: 5px;
  }
  img {
    display: inline-block;
    height: 30px;
    width: 48px;
  }
}
</style>
